module.exports = __webpack_public_path__ + "img/02.772a13ff.jpg";